import * as React from 'react';
import { forwardRef } from 'react';

export type DMLabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export const DMLabel = forwardRef<HTMLLabelElement, DMLabelProps>(
  ({ className = '', children, ...props }, ref) => {
    return (
      <label ref={ref} className={className} {...props}>
        {children}
      </label>
    );
  }
);
DMLabel.displayName = 'DMLabel';
